import React from "react";
import { FiCompass, FiTarget } from "react-icons/fi";
import { FaRegHandshake } from "react-icons/fa";
import "./about.css";
import about from "../Images/about.png";

const values = [
  {
    title: "Our Mission",
    description:
      "Deliver exceptional technology talent that enables organizations to innovate, grow, and succeed.",
    Icon: FiTarget,
  },
  {
    title: "Our Commitment",
    description:
      "Excellence, transparency, quality-driven recruitment, and long-term partnerships with every client.",
    Icon: FaRegHandshake,
  },
  {
    title: "Our Vision",
    description:
      "Become a trusted global technology staffing partner by connecting businesses with outstanding professionals.",
    Icon: FiCompass,
  },
];

export default function About() {
  return (
    <section id="about" className="zm-about">
      <div className="zm-container zm-about-inner">
        <div className="about-text">
          <span className="about-tag">ABOUT US</span>

          <h2>Building Strong Teams Through Exceptional Talent</h2>

          <p>
            At <strong>ZeitaMax</strong>, we believe that people are the
            foundation of every successful organization.
          </p>

          <p>
            Our expertise lies in identifying, evaluating, and delivering top
            technology professionals across a wide range of domains. Leveraging
            market intelligence, an extensive talent network, and a consultative
            approach, we help businesses overcome hiring challenges while
            empowering professionals to achieve meaningful careers.
          </p>

          <p>
            We are committed to excellence, transparency, and building
            relationships that create lasting value.
          </p>

          <div className="values" aria-label="Our values">
            <div className="values-track">
              {[...values, values[0]].map(({ title, description, Icon }, index) => (
                <article
                  className="val"
                  key={`${title}-${index}`}
                  aria-hidden={index === values.length ? "true" : undefined}
                >
                  <div className="val-icon" aria-hidden="true">
                    <Icon />
                  </div>
                  <div>
                    <h4>{title}</h4>
                    <p>{description}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>

        <div className="about-image">
          <img src={about} alt="About ZeitaMax" />
        </div>
      </div>
    </section>
  );
}
